exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-show-ortho-elastic .modal-dialog{max-width:40%}", ""]);

// exports
